import { ReferenceItem } from '../../../../../../types/types';

// Union of the current selection and newly selected items, deduplicated by value, current chips first.
export const mergeSelectedItems = (
  selectedItems: ReferenceItem[],
  newItems: ReferenceItem[]
): ReferenceItem[] => {
  const selectedValues = new Set(selectedItems.map(({ value }) => value));
  return [
    ...selectedItems,
    ...newItems.filter(({ value }) => !selectedValues.has(value)),
  ];
};
